export default __webpack_public_path__ + "static/media/Artboard 1.1.43302afe.jpg";